import { ThirdPartyServiceTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ThirdPartyServiceTrackingSchema: Record<
  ThirdPartyServiceTrackingPoint,
  string
> = {
  [ThirdPartyServiceTrackingPoint.BindRequirePhonePageView]:
    'ed0e4588-5ea2-4fd6-84c1-2bd421fc6986',
  [ThirdPartyServiceTrackingPoint.SubmitPhoneClick]:
    '3a066a20-d473-4520-9246-490e574d91f5',
  [ThirdPartyServiceTrackingPoint.AlreadyRegisteredPageView]:
    '27dd2274-28ac-40b3-9712-fbea03c2a5a5',
  [ThirdPartyServiceTrackingPoint.AlreadyRegisteredLoginClick]:
    '75aa616c-db4b-48ce-a7f2-517166388eed',
  [ThirdPartyServiceTrackingPoint.AlreadyRegisteredSignupClick]:
    '20a4dd05-5ffd-4775-bef9-60f98f6145d9',
  [ThirdPartyServiceTrackingPoint.BindingFlowLoginSuccessPageView]:
    '8cf0f00d-66f1-4cb4-a04a-486c57c11b05',
  [ThirdPartyServiceTrackingPoint.BindingFlowSignupSuccessPageView]:
    '48e57d79-abb5-444d-9d40-98f93f23eebd',
  [ThirdPartyServiceTrackingPoint.BindingFlowLoginFailedPageView]:
    '1daf209f-bf00-428b-80d2-ac2ab1a4446f',
  [ThirdPartyServiceTrackingPoint.BindingFlowSignupFailedPageView]:
    '24d121f2-41b8-4bdc-843c-15ef09e4e2a8',
};

export const getThirdPartyServicePageTypeAndSchema = (
  trackingPoint: ThirdPartyServiceTrackingPoint
) => {
  let pageType = '';
  switch (trackingPoint) {
    case ThirdPartyServiceTrackingPoint.BindRequirePhonePageView:
    case ThirdPartyServiceTrackingPoint.SubmitPhoneClick:
      pageType = PageType.ThirdPartyServiceBindingWithPhonePage;
      break;
    case ThirdPartyServiceTrackingPoint.AlreadyRegisteredPageView:
    case ThirdPartyServiceTrackingPoint.AlreadyRegisteredLoginClick:
    case ThirdPartyServiceTrackingPoint.AlreadyRegisteredSignupClick:
      pageType =
        PageType.ThirdPartyServiceBindingWithPhoneAlreadyRegisteredPage;
      break;
    case ThirdPartyServiceTrackingPoint.BindingFlowLoginSuccessPageView:
      pageType = PageType.ThirdPartyServiceLoginWithPhoneSuccessPage;
      break;
    case ThirdPartyServiceTrackingPoint.BindingFlowLoginFailedPageView:
      pageType = PageType.ThirdPartyServiceLoginWithPhoneFailedPage;
      break;
    case ThirdPartyServiceTrackingPoint.BindingFlowSignupSuccessPageView:
      pageType = PageType.ThirdPartyServiceSignupWithPhoneSuccessPage;
      break;
    case ThirdPartyServiceTrackingPoint.BindingFlowSignupFailedPageView:
      pageType = PageType.ThirdPartyServiceSignupWithPhoneFailedPage;
      break;
  }
  return {
    page_type: pageType,
    schema: ThirdPartyServiceTrackingSchema[trackingPoint],
  };
};
